import React from 'react';
import {Col, Container, Row} from 'react-bootstrap';


function Cancelation() {
  return (
    <div id="cancelation" className="cancelation pt50">
      <Container>
      <Row>
          <Col sm={12} className="mb50">
              <div className="section-title">Booking Policy</div>
              <h2>Cancellation Terms</h2>
              <p>
                  As this is our private home and not a hotel, every booking is carefully planned and the dates are
                  reserved exclusively for you. For this reason, <u>we are unable to provide refunds for cancelled
                  bookings.</u>
              </p>

              <p>
                  When making your reservation, you agreed to our booking terms, including our cancellation policy. We
                  understand that unexpected situations can happen, so <u>we'll be happy to move your booking to another
                  available date, provided you contact us at least 4 days before your scheduled check-in.</u>
              </p>

              <p>
                  <b>Thank you for your understanding</b> and for respecting our booking policy. If you have any
                      questions before or after making a reservation, please don't hesitate to contact us — we'll always do our
                      best to help.
              </p>
          </Col>
      </Row>
      </Container>
    </div>
  )
}

export default Cancelation;
